var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _rect3, _path7, _rect4, _path8, _rect5, _path9, _path10, _g, _circle, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdometerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 143,
    viewBox: "0 0 120 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#0473EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.916 56.9677C55.916 59.1912 57.7827 61.0002 60.0773 61.0002C62.3719 61.0002 64.2386 59.1912 64.2386 56.9677C64.2386 55.2756 62.1306 44.5562 60.0773 34.6453C58.0241 44.5562 55.916 55.2758 55.916 56.9677Z",
    fill: "#0473EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3643 28.74L43.1805 40.5562C47.0951 37.3244 51.9633 35.2094 57.293 34.6998V18C47.6363 18.5542 38.5845 22.3036 31.3643 28.74Z",
    fill: "#0473EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7831 32.2864L79.9668 44.1026C83.1987 48.0173 85.3136 52.8855 85.8232 58.2151H102.523C101.969 48.5584 98.2194 39.5066 91.7831 32.2864Z",
    fill: "#0473EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3027 18V34.6998C67.6323 35.2094 72.5005 37.3244 76.4152 40.5562L88.2314 28.74C81.0112 22.3036 71.9594 18.5542 62.3027 18Z",
    fill: "#0473EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0771 58.2151H33.777C34.2865 52.8855 36.4015 48.0173 39.6334 44.1026L27.8171 32.2864C21.3808 39.5066 17.6315 48.5584 17.0771 58.2151Z",
    fill: "#0473EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 68,
    width: 16,
    height: 21,
    rx: 3,
    stroke: "#0473EA",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4984 84.24C26.6824 84.24 25.9624 84.0667 25.3384 83.72C24.7144 83.368 24.2264 82.88 23.8744 82.256C23.5277 81.632 23.3544 80.912 23.3544 80.096V76.384C23.3544 75.568 23.5277 74.848 23.8744 74.224C24.2264 73.6 24.7144 73.1147 25.3384 72.768C25.9624 72.416 26.6824 72.24 27.4984 72.24C28.3144 72.24 29.0317 72.416 29.6504 72.768C30.2744 73.1147 30.7624 73.6 31.1144 74.224C31.4664 74.848 31.6424 75.568 31.6424 76.384V80.096C31.6424 80.912 31.4664 81.632 31.1144 82.256C30.7624 82.88 30.2744 83.368 29.6504 83.72C29.0317 84.0667 28.3144 84.24 27.4984 84.24ZM27.4984 82.408C27.9037 82.408 28.2717 82.312 28.6024 82.12C28.933 81.9227 29.1944 81.6613 29.3864 81.336C29.5784 81.0053 29.6744 80.6373 29.6744 80.232V76.24C29.6744 75.8293 29.5784 75.4613 29.3864 75.136C29.1944 74.8053 28.933 74.544 28.6024 74.352C28.2717 74.1547 27.9037 74.056 27.4984 74.056C27.093 74.056 26.725 74.1547 26.3944 74.352C26.0637 74.544 25.8024 74.8053 25.6104 75.136C25.4184 75.4613 25.3224 75.8293 25.3224 76.24V80.232C25.3224 80.6373 25.4184 81.0053 25.6104 81.336C25.8024 81.6613 26.0637 81.9227 26.3944 82.12C26.725 82.312 27.093 82.408 27.4984 82.408Z",
    fill: "#0C3A66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 68,
    width: 16,
    height: 21,
    rx: 3,
    stroke: "#0473EA",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4984 84.24C48.6824 84.24 47.9624 84.0667 47.3384 83.72C46.7144 83.368 46.2264 82.88 45.8744 82.256C45.5277 81.632 45.3544 80.912 45.3544 80.096V76.384C45.3544 75.568 45.5277 74.848 45.8744 74.224C46.2264 73.6 46.7144 73.1147 47.3384 72.768C47.9624 72.416 48.6824 72.24 49.4984 72.24C50.3144 72.24 51.0317 72.416 51.6504 72.768C52.2744 73.1147 52.7624 73.6 53.1144 74.224C53.4664 74.848 53.6424 75.568 53.6424 76.384V80.096C53.6424 80.912 53.4664 81.632 53.1144 82.256C52.7624 82.88 52.2744 83.368 51.6504 83.72C51.0317 84.0667 50.3144 84.24 49.4984 84.24ZM49.4984 82.408C49.9037 82.408 50.2717 82.312 50.6024 82.12C50.933 81.9227 51.1944 81.6613 51.3864 81.336C51.5784 81.0053 51.6744 80.6373 51.6744 80.232V76.24C51.6744 75.8293 51.5784 75.4613 51.3864 75.136C51.1944 74.8053 50.933 74.544 50.6024 74.352C50.2717 74.1547 49.9037 74.056 49.4984 74.056C49.093 74.056 48.725 74.1547 48.3944 74.352C48.0637 74.544 47.8024 74.8053 47.6104 75.136C47.4184 75.4613 47.3224 75.8293 47.3224 76.24V80.232C47.3224 80.6373 47.4184 81.0053 47.6104 81.336C47.8024 81.6613 48.0637 81.9227 48.3944 82.12C48.725 82.312 49.093 82.408 49.4984 82.408Z",
    fill: "#0C3A66"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 68,
    width: 16,
    height: 21,
    rx: 3,
    stroke: "#0473EA",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6122 84V74.584L68.4522 75.904V73.776L70.6122 72.48H72.5802V84H70.6122Z",
    fill: "#0C3A66"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 68,
    width: 16,
    height: 21,
    rx: 3,
    stroke: "#0473EA",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_971_4331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 64,
    width: 8,
    height: 28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0344 75.984V74.304L93.9624 69.912C94.3464 69.5707 94.613 69.248 94.7624 68.944C94.9117 68.64 94.9864 68.3467 94.9864 68.064C94.9864 67.68 94.9037 67.3387 94.7384 67.04C94.573 66.736 94.3437 66.496 94.0504 66.32C93.7624 66.144 93.429 66.056 93.0504 66.056C92.6504 66.056 92.2957 66.1493 91.9864 66.336C91.6824 66.5173 91.445 66.76 91.2744 67.064C91.1037 67.368 91.0237 67.696 91.0344 68.048H89.0504C89.0504 67.28 89.221 66.6107 89.5624 66.04C89.909 65.4693 90.3837 65.0267 90.9864 64.712C91.5944 64.3973 92.2957 64.24 93.0904 64.24C93.8264 64.24 94.4877 64.4053 95.0744 64.736C95.661 65.0613 96.1224 65.5147 96.4584 66.096C96.7944 66.672 96.9624 67.336 96.9624 68.088C96.9624 68.6373 96.8877 69.0987 96.7384 69.472C96.589 69.8453 96.365 70.1893 96.0664 70.504C95.773 70.8187 95.4077 71.168 94.9704 71.552L91.4744 74.648L91.2984 74.168H96.9624V75.984H89.0344Z",
    fill: "#0C3A66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6122 92V82.584L90.4522 83.904V81.776L92.6122 80.48H94.5802V92H92.6122Z",
    fill: "#0C3A66"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_971_4331)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 69,
    width: 10,
    height: 19,
    fill: "#0C3A66"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 121,
    r: 22,
    fill: "#3078FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7311 107.353C61.4815 105.93 63.5185 105.93 64.2689 107.353L67.3899 113.268C67.6793 113.817 68.2068 114.2 68.8179 114.306L75.4083 115.446C76.9929 115.72 77.6223 117.657 76.5015 118.811L71.84 123.607C71.4078 124.052 71.2063 124.672 71.2946 125.285L72.2467 131.906C72.4756 133.497 70.8276 134.695 69.3845 133.985L63.3825 131.034C62.826 130.76 62.174 130.76 61.6175 131.034L55.6155 133.985C54.1724 134.695 52.5244 133.497 52.7533 131.906L53.7054 125.285C53.7937 124.672 53.5922 124.052 53.16 123.607L48.4985 118.811C47.3777 117.657 48.0071 115.72 49.5917 115.446L56.1821 114.306C56.7932 114.2 57.3207 113.817 57.6101 113.268L60.7311 107.353Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdometerIcon);
export default __webpack_public_path__ + "static/media/odometer-icon.83a3fe099fd394e9a2c63cb97c3a25b9.svg";
export { ForwardRef as ReactComponent };